import { escapeHtml } from "./html";

type LoadedConfigurationSummary = {
  fileName: string;
  activeChannelCount: number;
  totalChannelCount: number;
};

type WriterStepsViewModel = {
  busy: boolean;
  showFileLoad: boolean;
  loaded: LoadedConfigurationSummary | null;
  injectedConfigSource: string;
};

function renderLoadFileCard(loaded: LoadedConfigurationSummary | null, busy: boolean): string {
  return `
    <article class="step-card">
      <div class="step-index">1</div>
      <h2 class="step-title">Choose a Configuration File</h2>
      <div class="actions">
        <button id="load-btn" class="primary" ${busy ? "disabled" : ""}>Choose</button>
      </div>
    </article>
  `;
}

function renderWriteFileCard(stepIndex: string, view: WriterStepsViewModel): string {
  return `
    <article class="step-card">
      <div class="step-index">${stepIndex}</div>
      <h2 class="step-title">Write to Receiver</h2>
      <div class="actions">
        <button id="write-btn" class="primary" ${(!view.loaded || view.busy) ? "disabled" : ""}>Write</button>
      </div>
    </article>
  `;
}

/** Renders the Load File and Write to Receiver action cards. */
export function renderWriterStepsView(view: WriterStepsViewModel): string {
  const writeStepIndex = view.showFileLoad ? "2" : "1";

  return `
    <section class="steps">
      <div class="steps-grid">
        ${view.showFileLoad ? renderLoadFileCard(view.loaded, view.busy) : ""}
        ${renderWriteFileCard(writeStepIndex, view)}
      </div>
    </section>
  `;
}
